import React, {useEffect} from 'react';
import { Header, Sidebar } from 'semantic-ui-react';

import { OfficeView, Favorites, Recents } from 'pages';
import { CloseableContent, Icon } from 'dyl-components';
import officeView from 'actions/office_view';
import { useDispatch, useSelector } from 'react-redux';

import './index.scss';
import TextPanel from 'shared/TextPanel';

export default function SecondarySideBar({
    isSidebarOpen,
    isActiveSecondarySidebar,
    onCloseSecondarySidebar,
    phone
}) {
    const dispatch = useDispatch();
    const useTicker = useSelector((state) => {
        const activeIdx = Object.values(state?.officeView?.calls)?.findIndex(call => call.connected > 0 || call.company_destination !== '');
        return (typeof activeIdx !== 'undefined') && activeIdx !== -1;
    });
    
    useEffect(() => {
        let tickerId;
        if(!useTicker){
             dispatch(officeView.currentCallTicker('CALL_CURRENT_TICKER', true));
        } else {
             tickerId = setInterval(() => {
                 dispatch(officeView.currentCallTicker('CALL_CURRENT_TICKER'));
             }, 1000);
         }
         return () => clearInterval(tickerId);
    }, [useTicker, dispatch]);

    return (
        <React.Fragment>
            <Sidebar
                animation='push'
                icon='labeled'
                vertical
                visible={isActiveSecondarySidebar('favorites')}
                className={`SideBar2 SideBar2--${isSidebarOpen ? 'open' : 'closed'}`}
                style={{ width: 380 }}
            >
                <div className='SidebarContainer'>
                    <CloseableContent onClose={onCloseSecondarySidebar}>
                        {isActiveSecondarySidebar("favorites") ? <Favorites /> : <></>}
                    </CloseableContent>
                </div>
            </Sidebar>

            <Sidebar
                animation='push'
                icon='labeled'
                vertical
                visible={isActiveSecondarySidebar('recents')}
                className={`SideBar2 SideBar2--${isSidebarOpen ? 'open' : 'closed'}`}
                style={{ width: 380 }}
            >
                <div className='SidebarContainer'>
                    <CloseableContent onClose={onCloseSecondarySidebar}>
                        {isActiveSecondarySidebar("recents") ? <Recents /> : <></>}
                    </CloseableContent>
                </div>
            </Sidebar>

            <Sidebar
                animation='push'
                icon='labeled'
                vertical
                visible={isActiveSecondarySidebar('view')}
                className={`SideBar2 SideBar2--wide SideBar2--${isSidebarOpen ? 'open' : 'closed'}`}>

                    {isActiveSecondarySidebar("view") ? <OfficeView isActive={isActiveSecondarySidebar('view')} onClose={onCloseSecondarySidebar} phone={phone} /> : <></>}
            </Sidebar>

            <Sidebar
                animation='push'
                icon='labeled'
                vertical
                visible={isActiveSecondarySidebar('text')}
                className={`SideBar2 SideBar2--wide SideBar2--${isSidebarOpen ? 'open' : 'closed'}`}>
                {isActiveSecondarySidebar('text') && (
                    <div style={{padding: 30}}>
                        <div style={{display: 'flex', marginBottom: 10}}>
                            <Header style={{flex: 1}} as={"h1"}>Text Messages</Header>
                            <Icon className='fa-solid fa-xmark closeIcon' size="big" onClick={onCloseSecondarySidebar} />
                        </div>
                        <TextPanel />
                    </div>
                )}
            </Sidebar>
        </React.Fragment>
    )
}
